import React from "react";
import { Map, Marker } from "pigeon-maps";

const MapView = () => {
  return (
    <div id="map" style={{ width: "100%", height: "422px" }}>
      <Map
        center={[12.976516360036827, 80.22266227470028]}
        zoom={12}
        height="422px"
        style={{ border: 0 }}
      >
        <Marker width={50} anchor={[12.976516360036827, 80.22266227470028]} />
      </Map>
    </div>
  );
};

export default MapView;
